import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import ProductInfo from '../components/ProductInfo';
import RelatedProducts from '../components/RelatedProducts';
import { allProductsData } from '../data/products';
import './ProductDetailsPage.css';

const ProductDetailsPage = () => {
    const { id } = useParams();

    // Find the product by ID (convert useParams string to Number)
    const product = allProductsData.find(p => p.id === Number(id));

    useEffect(() => {
        // Scroll to top when navigating to a new product
        window.scrollTo(0, 0);
    }, [id]);

    if (!product) {
        return (
            <div className="product-details-page">
                <Navbar />
                <main className="product-details-content product-not-found">
                    <h2>Product Not Found</h2>
                    <p>The equipment you are looking for does not exist.</p>
                </main>
                <Footer />
            </div>
        );
    }

    return (
        <div className="product-details-page">
            <Navbar />

            <main className="product-details-content">
                <ProductInfo product={product} />
                <RelatedProducts currentProductId={product.id} />
            </main>

            <Footer />
        </div>
    );
};

export default ProductDetailsPage;
